import { HTMLAttributes } from 'react'

import Grid from '@/components/base/grid'
import ImageParallax from '@/components/base/image-parallax'
import Media, { MediaElement } from '@/components/base/media'
import Section from '@/components/base/section'

import { cn } from '@/lib/utils'

export type FullscreenMediaProps = HTMLAttributes<HTMLDivElement> &
  Partial<{ media: MediaElement; use_overlay: boolean }>

const FullscreenMedia = ({
  media,
  use_overlay,
  className,
  ...props
}: FullscreenMediaProps) => {
  return (
    <Section className={cn('px-margin lg:px-0', className)} {...props}>
      <Grid>
        <div
          className={cn(
            'col-span-2 md:col-span-4 md:col-start-2',
            'lg:col-auto lg:row-span-12 lg:w-screen'
          )}
        >
          <div
            className={cn('relative h-auto w-full lg:h-full lg:w-full', {
              'after:absolute after:left-0 after:top-0 after:h-full after:w-full after:bg-black/45':
                use_overlay
            })}
          >
            <ImageParallax disable={media?.use_video}>
              {(imageRef) => (
                <Media
                  ref={imageRef}
                  fit="cover"
                  className="h-auto w-full lg:h-full lg:w-full"
                  {...media}
                />
              )}
            </ImageParallax>
          </div>
        </div>
      </Grid>
    </Section>
  )
}

export default FullscreenMedia
